import PropTypes from 'prop-types';

export default function LoadingSpinner({show}) {
  return (
    <div
      className={`w-full top-0 bottom-0 left-0 right-0 absolute flex items-center justify-center pointer-events-none transition-opacity ${show ? 'opacity-100' : 'opacity-0'}`}
    >
      <span className="loading loading-spinner loading-md"></span>
    </div>
  )
}

LoadingSpinner.propTypes = {
  show: PropTypes.bool.isRequired,
}